"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
var intercomAppId = 'zj1fxfxa';
var config = function (environment) {
    switch (environment) {
        case 'development':
        case 'testing':
            return {
                Environment: environment,
                IntercomAppId: intercomAppId,
                Api: {
                    CONFIG_HOST: 'https://fe-configuration-testing.in.globalwebindex.com',
                    SUSI_HOST: 'signin-testing.globalwebindex.com',
                    CORE_USERS_HOST: 'api-testing.globalwebindex.com',
                    ANALYTICS_HOST: 'https://api-testing.globalwebindex.com/v1/analytics',
                    CURRENT_PLATFORM_HOST: 'https://app-testing.globalwebindex.com/'
                }
            };
        case 'staging': {
            return {
                Environment: environment,
                IntercomAppId: intercomAppId,
                Api: {
                    CONFIG_HOST: 'https://fe-configuration-staging.in.globalwebindex.com',
                    SUSI_HOST: "signin-staging.globalwebindex.com",
                    CORE_USERS_HOST: 'api-staging.globalwebindex.com',
                    ANALYTICS_HOST: 'https://api-staging.globalwebindex.com/v1/analytics',
                    CURRENT_PLATFORM_HOST: 'https://app-staging.gwi.com/'
                }
            };
        }
        case 'production': {
            return {
                Environment: environment,
                IntercomAppId: intercomAppId,
                Api: {
                    CONFIG_HOST: 'https://api.globalwebindex.com/v1/fe-configuration',
                    SUSI_HOST: 'signin.globalwebindex.com',
                    CORE_USERS_HOST: 'api.globalwebindex.com',
                    ANALYTICS_HOST: 'https://api.globalwebindex.com/v1/analytics',
                    CURRENT_PLATFORM_HOST: 'https://app.globalwebindex.com/'
                }
            };
        }
        default: {
            return {
                Environment: 'Undefined Environment',
                IntercomAppId: intercomAppId,
                Api: {
                    CONFIG_HOST: '',
                    SUSI_HOST: '',
                    CORE_USERS_HOST: '',
                    ANALYTICS_HOST: '',
                    CURRENT_PLATFORM_HOST: ''
                }
            };
        }
    }
};
exports.config = config;
